namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_book, {
		position: 'absolute',
		inset: '0',
		width: '100%',
		height: '100%',
		minWidth: 0,
		minHeight: 0,
		maxHeight: '100%',
		overflow: 'hidden',

		Navigation: {
			flexDirection: 'column',
			gap: 0,
		},

		Menu: {
			flex: { basis: '16rem', grow: 0, shrink: 0 },
		},
	} )

}
